import { LEGACY_TEAM_ACCESS } from 'domains/legacy-feature/access'
import LegacyOperationPage from 'domains/legacy-operation/pages/legacy-operation-page'
import React from 'react'

const legacyOperationPage = (resourceKey) => (props) => <LegacyOperationPage { ...props } resourceKey={ resourceKey } />

const legacy_operations_routes = {
  collapse  : true,
  path      : '/legacy-operations',
  name      : 'Legacy Operations',
  icon      : 'fas fa-archive text-gray',
  state_key : 'legacy_operations_collapse',
  views     : [
    {
      path         : '/legacy-operations/transits',
      name         : 'Transit',
      miniName     : 'TR',
      component    : legacyOperationPage('transits'),
      layout       : '/app',
      allowedRoles : LEGACY_TEAM_ACCESS.Operations.allowedRoles,
      allowedEmails: LEGACY_TEAM_ACCESS.Operations.allowedEmails
    },
    {
      path         : '/legacy-operations/outbounds',
      name         : 'Outbound',
      miniName     : 'OB',
      component    : legacyOperationPage('outbounds'),
      layout       : '/app',
      allowedRoles : LEGACY_TEAM_ACCESS.Operations.allowedRoles,
      allowedEmails: LEGACY_TEAM_ACCESS.Operations.allowedEmails
    },
    {
      path         : '/legacy-operations/tanda-keluars',
      name         : 'Tanda Keluar',
      miniName     : 'TK',
      component    : legacyOperationPage('tanda_keluars'),
      layout       : '/app',
      allowedRoles : LEGACY_TEAM_ACCESS.Operations.allowedRoles,
      allowedEmails: LEGACY_TEAM_ACCESS.Operations.allowedEmails
    },
    {
      path         : '/legacy-operations/carts',
      name         : 'Carts',
      miniName     : 'CA',
      component    : legacyOperationPage('carts'),
      layout       : '/app',
      allowedRoles : LEGACY_TEAM_ACCESS.Sales.allowedRoles,
      allowedEmails: LEGACY_TEAM_ACCESS.Sales.allowedEmails
    },
    {
      path         : '/legacy-operations/pickups',
      name         : 'Pickup',
      miniName     : 'PU',
      component    : legacyOperationPage('pickups'),
      layout       : '/app',
      allowedRoles : LEGACY_TEAM_ACCESS.Operations.allowedRoles,
      allowedEmails: LEGACY_TEAM_ACCESS.Operations.allowedEmails
    },
    {
      path         : '/legacy-operations/pickup-products',
      name         : 'Pickup Products',
      miniName     : 'PP',
      component    : legacyOperationPage('pickup_products'),
      layout       : '/app',
      allowedRoles : LEGACY_TEAM_ACCESS.Operations.allowedRoles,
      allowedEmails: LEGACY_TEAM_ACCESS.Operations.allowedEmails
    }
  ]
}

export default legacy_operations_routes
